import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import Pagination from 'assets/components/pagination/Pagination';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { HttpStatus, productManagementHomeRoute } from 'config/Api.Config';
import { isMobile } from 'react-device-detect';
import useRefundConfigTemplate, { RefundConfigTemplateAction } from './RefundConfigTemplate.Hooks';
import { DataProvider } from 'assets/providers/data/DataProvider';
import Page from 'assets/components/page/Page';
import Button from 'assets/components/button/Button';
import RefundConfigTemplateList from './sections/RefundConfigTemplate.List';
import RefundConfigTemplateDelete from './sections/RefundConfigTemplate.Delete';
import RefundConfigTemplateFilters from './sections/RefundConfigTemplate.Filters';
import RefundConfigTemplateEdit from './sections/RefundConfigTemplate.Edit';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

export const refundConfigTemplateIndexRoute = productManagementHomeRoute + '/refund-config-template/:action?/:id?';
export default function RefundConfigTemplateIndex() {
  const { lang } = getLocales();
  const refundConfigTemplateHook = useRefundConfigTemplate();

  if (!refundConfigTemplateHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={refundConfigTemplateHook}
        render={({ listApi, views, pageRouter, permissions }) => (
          <Page
            class={ThemePageList}
            isLoading={listApi.isExecuting}
            header={
              <>
                <h2 style={{ marginRight: 'auto' }} children={lang.refundConfigTemplates} />
                <Box class={ThemeWrapperStack}>
                  {isMobile && <RefundConfigTemplateFilters />}
                  <Button
                    class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                    active
                    media={<Icon class="fas-plus" />}
                    render={!isMobile && lang.addNew}
                    onClick={pageRouter.updateParams}
                    disabled={!permissions.CREATE_REFUNDCONFIGTEMPLATE}
                    data={{ action: RefundConfigTemplateAction.EDIT, id: undefined }}
                  />
                </Box>
              </>
            }
            subHeader={!isMobile && <RefundConfigTemplateFilters />}
            render={
              <>
                {views.edit && <RefundConfigTemplateEdit />}
                {views.delete && <RefundConfigTemplateDelete />}
                <RefundConfigTemplateList />
              </>
            }
            footer={
              <Pagination
                class={ThemePaginationRounded}
                count={listApi.payload?.count}
                offset={listApi.body?.offset}
                limit={listApi.body?.limit}
                onLimitChange={(limit) => listApi.execute((body) => ({ ...body, limit, offset: 0 }))}
                onOffsetChange={(offset) => listApi.execute((body) => ({ ...body, offset }))}
              />
            }
          />
        )}
      />
    </>
  );
}
